import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicySchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy | Airport Parking Deals",
    "description": "Read our privacy policy to understand how Airport Parking Deals collects, uses, and protects your personal information when booking airport parking.",
    "url": "https://airportparkingdeals.co.uk/privacy-policy",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://airportparkingdeals.co.uk"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Privacy Policy",
          "item": "https://airportparkingdeals.co.uk/privacy-policy"
        }
      ]
    },
    "about": {
      "@type": "Thing",
      "name": "Privacy Policy",
      "description": "Airport Parking Deals' commitment to protecting your personal data and privacy when using our airport parking comparison service."
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default PrivacyPolicySchema;

